<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Application",
  watch: {
    $route(newValue) {
      this.$store.dispatch("setActiveName", "index");
    }
  }
};
</script>

<style>
#app {
  height: 100%;
  width: 100%;
}
</style>
